import type { InterviewConfig, SessionSummary } from './types';

export const roles = [
  'Software Engineer',
  'AI/ML Engineer',
  'Data Engineer',
  'Platform Engineer',
  'Engineering Manager',
  'Product Manager',
  'Data Scientist',
  'UX Designer',
  'Sales Manager',
  'Marketing Lead',
];

export const interviewTypes = [
  'Project walkthrough',
  'Live screen walkthrough',
  'Take-home debrief',
  'AI engineering interview',
  'System design interview',
  'Behavioral interview',
  'Technical screen',
  'Hiring manager interview',
  'Leadership interview',
  'Case interview',
];

export const defaultConfig: InterviewConfig = {
  role: roles[0],
  interviewType: interviewTypes[0],
  difficulty: 'standard',
  mode: 'voice',
  contextIds: [],
};

export const demoSessions: SessionSummary[] = [
  { id: 's1', role: 'Software Engineer', interviewType: 'Behavioral interview', mode: 'voice', status: 'completed', score: 82, durationMinutes: 18, createdAt: '2026-07-30T10:00:00Z' },
  { id: 's2', role: 'Software Engineer', interviewType: 'Technical screen', mode: 'text', status: 'completed', score: 76, durationMinutes: 24, createdAt: '2026-07-27T10:00:00Z' },
  { id: 's3', role: 'Product Manager', interviewType: 'Case interview', mode: 'avatar', status: 'completed', score: 71, durationMinutes: 16, createdAt: '2026-07-22T10:00:00Z' },
];
